import React, { Fragment } from "react";
import { Client } from ".";
import { classNames } from "./utils/classNames";
import { setIcon } from "./utils/icons";
import { useThemeContext } from "./theming/useThemeContext";
import { useIconWithTextClasses, usePrependAppendStatusLabelClasses, useStatusLabelBodyClasses, useStatusLabelClasses, } from "./StatusLabel/StatusLabel.styles";
export const StatusLabel = (props) => {
    const { client } = useThemeContext();
    const { append, prepend } = props;
    const classes = useStatusLabelClasses(getDefaultComponentSize(client, props?.size), !!(prepend || append), props?.color);
    return (React.createElement("span", { className: classNames("status-label", props?.color, props?.extraClass || "", classes.statusLabel), "data-id": props?.dataId, "data-testid": props?.dataTestId, role: props?.role ?? undefined, "data-hook": props?.dataHook, "data-size": props?.size },
        prepend && React.createElement(StatusLabelPrepend, { ...props }),
        React.createElement(StatusLabelBody, { ...props }),
        append && React.createElement(StatusLabelAppend, { ...props })));
};
const StatusLabelPrepend = (props) => {
    const { client } = useThemeContext();
    const classes = usePrependAppendStatusLabelClasses(getDefaultComponentSize(client, props.size), props?.color);
    return (React.createElement("span", { className: classNames("status-label--prepend", classes.prepend) }, props?.prepend));
};
const StatusLabelBody = (props) => {
    const { client } = useThemeContext();
    const { text, glyph, size } = props;
    const prependAppend = !!(props?.prepend || props?.append);
    const { additionalText } = useStatusLabelBodyClasses(!!glyph, prependAppend);
    if (prependAppend) {
        return (React.createElement("span", { className: classNames("status-label--text", additionalText) },
            React.createElement(StatusLabelContent, { message: text, glyph: glyph, iconSize: getDefaultComponentSize(client, size), description: props?.description })));
    }
    return (React.createElement(StatusLabelContent, { message: text, glyph: glyph, iconSize: getDefaultComponentSize(client, size), description: props?.description }));
};
const StatusLabelAppend = (props) => {
    const { client } = useThemeContext();
    const classes = usePrependAppendStatusLabelClasses(getDefaultComponentSize(client, props.size), props?.color);
    return (React.createElement("span", { className: classNames("status-label--append", classes.append) }, props?.append));
};
const StatusLabelContent = ({ message, glyph, glyphColor, iconSize, description }) => {
    let { iconType, iconValue } = setIcon(glyph);
    const classes = useIconWithTextClasses(iconSize, iconType);
    if (!glyph)
        return (React.createElement(Fragment, null,
            message,
            description && (React.createElement("span", { className: classNames(classes.srOnly, "pl-2") },
                " ",
                description))));
    return (React.createElement("span", { className: classNames("status-label--icon-wrapper", classes.wrapper) },
        React.createElement("span", { style: { color: glyphColor }, className: classNames("status-label--icon", classes.icon, iconType ?? "", `${iconType}-${iconValue}`) }),
        React.createElement("span", { className: `status-label--text ${classes.message}` },
            message,
            description && (React.createElement("span", { className: classNames(classes.srOnly, "pl-2") },
                " ",
                description)))));
};
export const getDefaultComponentSize = (client, size) => size ?? (client === Client.Portal ? "small" : "medium");
